import { ReactNode } from 'react'
import { CalendarIcon } from '../../../../assets/icons/CalendarIcon'
import { EnvironmentIcon } from '../../../../assets/icons/EnvironmentIcon'
import { BankIcon } from '../../../../assets/icons/BankIcon'
import { UserIcon } from '../../../../assets/icons/UserIcon'
import { JurisdictionsCircleIcon } from '../../../../assets/icons/JurisdictionsCircleIcon'

export const overviewMapping: {
  key: string
  label: string
  tooltipText?: string
  icon?: ReactNode
}[] = [
  { key: 'founded', label: '', icon: <CalendarIcon size={14} /> },
  { key: 'location', label: '', icon: <EnvironmentIcon size={14} /> },
  { key: 'entityType', label: 'Company Type', icon: <BankIcon size={14} /> },
  { key: 'allEmployees', label: 'Employees', icon: <UserIcon size={14} /> },
  { key: 'jurisdictions', label: 'Jurisdictions', icon: <JurisdictionsCircleIcon size={14} /> },
]
